import React, { useState, FC, useEffect } from 'react';
import { FrequentlySentence } from './frequently-sentence';
import { reportQueries, useReportStore } from '@/entities/report';
import AiPlainLanguage from './ai-plain-language';
import { usePersistStore } from '@/shared/lib/store';

interface AiReviewProps {
    evalId: number;
    stntId: string;
}
export type selectTab = 'frequently' | 'ai';

export const AiReview: FC<AiReviewProps> = ({ stntId, evalId }) => {
    const { stntReport } = useReportStore();
    const { sUserId } = usePersistStore();
    // 탭 상태: 'frequently'는 자주 쓰는 문장, 'ai'는 AI 평어 입력폼
    const [activeTab, setActiveTab] = useState<selectTab>('ai');
    // 전체 총평 텍스트 (생성된 총평이 여기에 기록됨)
    const [overallReview, setOverallReview] = useState<string>('');
    const [review, setReview] = React.useState<string>('');
    const [ischecked, setIsChecked] = React.useState(false);
    const [modalState, setModalState] = React.useState(false);
    const [modalText, setModalText] = React.useState('');

    // AI 평어 관련 데이터를 react-query를 통해 가져옴
    const { data, isLoading } = reportQueries.review.getTchReportEvalGeneralReviewAiEvlWord(
        {
            evlId: evalId,
            textbkTabId: stntReport?.textbkId,
            userId: stntId,
        },
        !!evalId && !!stntId && !!stntReport?.textbkId
    );

    const { data: getAiEvlWord, refetch: aiEvlRefetch } =
        reportQueries.review.getTchReportEvalGeneralReviewAiEvlWord(
            {
                evlId: evalId,
                userId: stntId,
            },
            !!evalId && !!stntId
        );

    const { data: getTotalReview, refetch: totalReviewRefetch } =
        reportQueries.review.getReportEvalReviewInfo(
            {
                evlId: evalId,
                userId: stntId,
            },
            !!evalId && !!stntId
        );

    const { mutate: saveReview } = reportQueries.review.postReportEvalReviewSave();

    // 기존의 saveClickHandler를 새 API를 호출하는 방식으로 수정
    const saveClickHandler = (genrvw: string, stdtPrntRlsAt: string) => {
        // 로그 확인 (필요 시)
        saveReview(
            { evlId: evalId, userId: stntId, genrvw, stdtPrntRlsAt },
            {
                onSuccess: (res) => {
                    if (res?.resultOk) {
                        showTextModal('저장했습니다.');
                        // 화면 스크롤 이동
                    } else showTextModal('저장에 실패했습니다.');
                },
                onError: () => {
                    showTextModal('저장에 실패했습니다.');
                },
            }
        );
    };

    const addReview = (sents: string) => {
        setOverallReview(overallReview + '\n' + sents);
    };

    const changeReview = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReview(e.target.value);
    };

    const toggleGenrvw = () => {
        setIsChecked(!ischecked);
    };

    const onCopy = async () => {
        try {
            await navigator.clipboard.writeText(overallReview);
            showTextModal('복사가 완료되었습니다.');
        } catch (error) {
            showTextModal('복사를 실패했습니다.');
        }
    };

    const showTextModal = (text: string) => {
        setModalText(text);
        setModalState(true);
        setTimeout(() => {
            setModalText('');
            setModalState(false);
        }, 2000);
    };

    useEffect(() => {
        if (stntReport.mainTab !== '상세 보기') {
            const tabElement = document.getElementById('tab_02');
            tabElement &&
                tabElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
    }, [stntReport]);

    useEffect(() => {
        aiEvlRefetch();
        totalReviewRefetch();
    }, [stntId]);

    useEffect(() => {
        setOverallReview(getTotalReview?.genrvw ? getTotalReview?.genrvw : '');
        setIsChecked(getTotalReview?.stdtPrntRlsAt === 'Y');
    }, [getTotalReview]);

    // if (!data) return null;

    return (
        <>
            {' '}
            {/* // 25.06.10 ai 총평 작성 */}
            <div className="cont" id="review-top">
                <div className="feedbackWrap" id="review-top">
                    {/* 25.06.10 ai 총평 작성 */}
                    <div className="tit2">
                        <div className="txt">
                            {/* 학생일때 문구: 아래는 선생님이 평가에 대해 작성한 총평이에요. */}
                            우리 반 리포트에서 작성한 AI 총평이 보여집니다. <br />
                            총평을 누르면 문구를 수정할 수 있습니다.
                        </div>
                    </div>

                    {/* 기 작성한  ai 총평이 없을 때*/}
                    <div className="box-type-bg total-all-feedback">
                        {/* 학생일때 미노출 영역 */}
                        <div className="tit-util">
                            <div className="flex-item al-center">
                                <div className="top_s_tit">
                                    *
                                    <button type="button" className="ex_small_bt">
                                        AI 총평 생성
                                    </button>
                                    을 클릭하면 AI총평을 작성할 수 있습니다.
                                </div>
                                <div className="top_s_tit">
                                    * 화면을 나가기 전에 반드시{' '}
                                    <span className="ex_small_bt">수정하기</span> 를 눌러야 다시
                                    접속했을 때 총평이 남겨 있습니다.
                                </div>
                            </div>
                        </div>
                        {/* //학생일때 미노출 영역 */}
                        <div className="total-view-text-box">
                            <p>
                                학생은 이차방정식의 해를 구하는 기본 개념을 이해하고 있으며, 이를
                                활용하여 간단한 이차방정식의 해를 구할 수 있습니다.
                                <br />
                                그러나 복잡한 이차방정식의 해를 구하거나 인수분해를 해야 하는
                                문제에서는 여전히 어려움을 느끼고 있습니다. 모둠 활동 시간에
                                적극적으로 참여하며, 친구들에게 친절하게 설명해주는 등 순한 성격
                                덕분에 다른 사람과의 소통 능력이 뛰어납니다. 자신이 부족한 부분을
                                인지하고 있기 때문에 “조금만 더 노력하자”라고 말하며 자기 발전을
                                위해 꾸준히 노력하는 자세를 가지고 있습니다.
                            </p>
                        </div>
                    </div>
                    {/* //기 작성한  ai 총평이 없을 때*/}

                    {/* 기 작성한  ai 총평이 있을 때*/}
                    <div className="box-type-bg total-all-feedback">
                        <div className="tit-util">
                            <div className="flex-item al-center">
                                <div className="top_s_tit">
                                    *
                                    <button type="button" className="ex_small_bt">
                                        AI 총평 생성
                                    </button>
                                    을 클릭하면 AI총평을 작성할 수 있습니다.
                                </div>
                                <div className="top_s_tit">
                                    * 화면을 나가기 전에 반드시{' '}
                                    <span className="ex_small_bt">수정하기</span> 를 눌러야 다시
                                    접속했을 때 총평이 남겨 있습니다.
                                </div>
                            </div>
                        </div>
                        <div className="total-textarea">
                            <div className="text-box">
                                <textarea></textarea>
                                <div className="bl-q-placeholder">
                                    <p className="txt-l">학생에게 총평을 남기는 공간입니다.</p>
                                    <p className="txt-s">
                                        우리 반 리포트에서 AI 평어 기능을 사용해서 총평을 작성하기를
                                        추천 드립니다!
                                        <br />
                                        우리 반 리포트에서 [저장하기]를 누르면 작성한 총평이 현재
                                        화면에 자동으로 보여집니다. (덮어쓰기)
                                        <br />
                                        선생님은 문구를 언제든지 수정할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* //기 작성한  ai 총평이 있을 때*/}
                    <div className="mgt30 bt_wrap">
                        <button className="btn-v2 btn-lg primary">수정하기</button>
                    </div>
                </div>

                {/* 탭에 따른 컴포넌트 분기 */}
                {activeTab === 'frequently' ? (
                    <FrequentlySentence addReview={addReview} showTextModal={showTextModal} />
                ) : (
                    // AiPlainLanguage에 stntId, metaIdList, 그리고 생성된 총평을 상위 TextBox에 업데이트하는 콜백 전달
                    <AiPlainLanguage
                        stntId={stntId}
                        metaIdList={data?.metaIdList}
                        onReviewGenerated={(reviewText) => setOverallReview(reviewText)}
                        showTextModal={showTextModal}
                    />
                )}
                <div className={`save-success ${modalState && 'isShow'}`} role="alert">
                    {modalText}
                </div>
            </div>
            {/* // 25.06.10 ai 총평 작성 */}
            {/*<div className="total-all-feedback" id="review-top">
                <div className="tit-util" id="review-top">
                    <div className="flex-item al-center">
                        <h5 className="tit-result">총평</h5>
                        <button className="btn btn-default darkblue" onClick={onCopy}>
                            복사하기
                        </button>
                    </div>
                    <span className="flex-item al-center">
                        <span>학생 공개</span>
                        <InputToggle tgl_type="type1" checked={ischecked} onChange={toggleGenrvw} />
                        <button
                            className="btn btn-default blue"
                            onClick={() => saveClickHandler(overallReview, ischecked ? 'Y' : 'N')}
                        >
                            저장하기
                        </button>
                    </span>
                </div>
                 총평 작성 영역 - 생성된 총평은 여기 TextBox에 표시
                <div className="total-textarea">
                    <TextBox
                        type="textarea"
                        value={overallReview}
                        onChange={(e) => setOverallReview(e.target.value)}
                        elPh={
                            <div className="bl-q-placeholder">
                                <p className="txt-l">세트지에 대한 총평을 남기는 공간입니다.</p>
                                <p className="txt-s">
                                    '학생 공개'를 키면 (ON) 학생과 학부모에게 글이 공개됩니다.
                                    <br />
                                    끄면(OFF) 교사만 확인 가능하고 그들에게 보이지 않습니다.
                                </p>
                            </div>
                        }
                    />
                </div>
                 <div className="total-textarea">
                    <div className="ai-result">
                        <p className="value-text">오늘 수업 태도가 평소보다 바르고 집중을 잘함</p>
                        <p className="ai-title">AI 평어:</p>
                        <p className="value-text">
                            학생은 각과 직각의 개념을 잘 이해하고, 이를 활용하여 예각과 둔각을 구별하는
                            활동을 잘 수행함. 수업 시간에는 집중력을 발휘하여 선생님의 설명을 잘 듣고,
                            질문에 적극적으로 대답함. 또, 과제를 성실하게 수행하여 자신의 학습한 내용을
                            스스로 점검하고 보완함
                        </p>
                    </div>
                </div>
                 탭 버튼
                <div className="tab-button base-box box-type3">
                    <div className="tab">
                        <button
                            type="button"
                            className={`btn btn-default round midgray ${activeTab === 'ai' ? 'isActive' : ''}`}
                            id="tab_02__label"
                            onClick={() => setActiveTab('ai')}
                        >
                            AI 평어
                            <TextCloud btnClass="btn-type2" boxClass="type3" noBtn={true}>
                                <p>
                                    ※ 빠르고 편하게 피드백을 작성하려면 학생 맞춤
                                    <br /> 총평을 자동으로 생성하는 AI 평어를 이용해보세요​
                                </p>
                                <br />
                                <p>
                                    <strong>사용 방법</strong> : 범위, 수준, 활동, 태도, 키워드를
                                    입력하고
                                    <br /> ‘AI 평어 생성’ 버튼을 누르면 위쪽 총평란에 자동으로 글이
                                    생성됩니다.
                                </p>
                            </TextCloud>
                        </button>
                    </div>
                    <div className="tab">
                        <button
                            type="button"
                            className={`btn btn-default round midgray ${activeTab === 'frequently' ? 'isActive' : ''}`}
                            id="tab_01__label"
                            onClick={() => setActiveTab('frequently')}
                        >
                            자주 쓰는 문장
                        </button>
                    </div>
                </div>
                 탭에 따른 컴포넌트 분기
                {activeTab === 'frequently' ? (
                    <FrequentlySentence addReview={addReview} showTextModal={showTextModal} />
                ) : (
                    // AiPlainLanguage에 stntId, metaIdList, 그리고 생성된 총평을 상위 TextBox에 업데이트하는 콜백 전달
                    <AiPlainLanguage
                        stntId={stntId}
                        metaIdList={data?.metaIdList}
                        onReviewGenerated={(reviewText) => setOverallReview(reviewText)}
                        showTextModal={showTextModal}
                    />
                )}
                <div className={`save-success ${modalState && 'isShow'}`} role="alert">
                    {modalText}
                </div>
            </div>*/}
        </>
    );
};

export default AiReview;
